"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../constants/themeContants");

var _theming = require("../../theming");

var _ThemeComponent = _interopRequireDefault(require("../Theme/ThemeComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Portal = function Portal(_ref) {
  var label = _ref.label,
      tagName = _ref.tagName,
      variant = _ref.variant,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["label", "tagName", "variant", "className"]);

  return _react["default"].createElement(PortalWrapper, _extends({
    className: className
  }, rest, {
    variant: variant
  }), _react["default"].createElement(IconWrapper, _extends({
    variant: variant
  }, rest), _react["default"].createElement(_ThemeComponent["default"], {
    tagName: tagName
  })), _react["default"].createElement(Label, _extends({
    variant: variant
  }, rest), label));
};

Portal.themeProps = {
  label: {
    name: "PORTAL_LABEL",
    description: "Styling for the text-element (div)",
    type: _themeContants.themePropTypes.style
  },
  iconWrapper: {
    name: "PORTAL_ICON_WRAPPER",
    description: "Styling for the circle around the icon (div)",
    type: _themeContants.themePropTypes.style
  },
  icon: {
    name: "PORTAL_ICON",
    description: "Styling for the icon (svg)",
    type: _themeContants.themePropTypes.style
  },
  portalWrapper: {
    name: "PORTAL_Wrapper",
    description: "Styling for wrapper around the component (div)",
    type: _themeContants.themePropTypes.style
  }
};

var Label = _styledComponents["default"].div.withConfig({
  displayName: "Portal__Label",
  componentId: "yss2ee-0"
})(["", ";"], (0, _theming.applyVariants)(Portal.themeProps.label));

var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Portal__IconWrapper",
  componentId: "yss2ee-1"
})(["border-radius:50%;width:", ";height:", ";background-color:", ";margin-bottom:", ";margin-left:auto;margin-right:auto;display:flex;justify-content:center;align-items:center;svg{fill:", ";", ";}", ";"], (0, _theming.spacing)("largePlus"), (0, _theming.spacing)("largePlus"), _theming.color.subtleHover, _theming.spacing.tiny, _theming.color.primary, (0, _theming.applyVariants)(Portal.themeProps.icon), (0, _theming.applyVariants)(Portal.themeProps.iconWrapper));

var PortalWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Portal__PortalWrapper",
  componentId: "yss2ee-2"
})(["display:inline-block;text-align:center;color:currentColor;", ";"], (0, _theming.applyVariants)(Portal.themeProps.portalWrapper));

Portal.defaultProps = {
  className: null
};
Portal.propTypes = {
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  tagName: _propTypes["default"].string,
  variant: _propTypes["default"].string
};
var _default = Portal;
exports["default"] = _default;